export class RangoFechas {
    nombre?:any;
    fecini?:any;
    fecfin?:any;
    id?:any;

    constructor(){}
}
